const Star = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#FFD400",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="8163"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M512 85.9l138.4 280.5 309.6 45-224 218.4 52.9 308.3L512 792.5 235.1 938.1 288 629.8 64 411.4l309.6-45z"
      fill={color}
      p-id="8164"
    ></path>
  </svg>
);

export default Star;
